<form [formGroup]="counterpartForm">
    <ng-container>
        <app-form-section>
            <app-form-row>
                <app-form-group>
                    <label for="companyName">{{ 'FEATURES.COUNTERPART.NAME' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="companyName"
                        formControlName="companyName"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.companyName"
                        languageKey="FEATURES.COUNTERPART.NAME"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="organizationNo">{{ 'FEATURES.COUNTERPART.ORGNO' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="organizationNo"
                        formControlName="organizationNo"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.organizationNo"
                        languageKey="FEATURES.COUNTERPART.ORGNO"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="address">{{ 'FEATURES.COUNTERPART.ADDRESS' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="address"
                        formControlName="address"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.address"
                        languageKey="FEATURES.COUNTERPART.ADDRESS"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="zipCode">{{ 'FEATURES.COUNTERPART.ZIPCODE' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="zipCode"
                        formControlName="zipCode"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.zipCode"
                        languageKey="FEATURES.COUNTERPART.ZIPCODE"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="city">{{ 'FEATURES.COUNTERPART.CITY' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="city"
                        formControlName="city"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.city"
                        languageKey="FEATURES.COUNTERPART.CITY"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="country">{{ 'FEATURES.COUNTERPART.COUNTRY' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="country"
                        formControlName="country"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.country"
                        languageKey="FEATURES.COUNTERPART.COUNTRY"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="website">{{ 'FEATURES.COUNTERPART.WEBSITE' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="website"
                        formControlName="website"
                        type="text"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="title">{{ 'FEATURES.COUNTERPART.TITLE' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="title"
                        formControlName="title"
                        type="text"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="fullname">{{ 'FEATURES.COUNTERPART.FULLNAME' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="fullname"
                        formControlName="fullname"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.fullname"
                        languageKey="FEATURES.COUNTERPART.FULLNAME"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="phone">{{ 'FEATURES.COUNTERPART.PHONE' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="phone"
                        formControlName="phone"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.phone"
                        languageKey="FEATURES.COUNTERPART.PHONE"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="email">{{ 'FEATURES.COUNTERPART.EMAIL' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="email"
                        formControlName="email"
                        type="text"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.email"
                        languageKey="FEATURES.COUNTERPART.EMAIL"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="linkedin">{{ 'FEATURES.COUNTERPART.LINKEDIN' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="linkedin"
                        formControlName="linkedin"
                        type="text"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row *ngIf="!counterpart">
                <app-form-group>
                    <button
                        type="submit"
                        class="primary"
                        (click)="save()"
                        [class.loading]="loading"
                        [disabled]="isDisabled()"
                    >
                        {{ 'BUTTONS.SAVE' | translate }}
                    </button>
                </app-form-group>
            </app-form-row>
        </app-form-section>
    </ng-container>
</form>
